import i18next from 'i18next';

import { ChatGroupRoomUserApi } from '../api/chatGroupRoomUserApi';

const beforeunloadMessage = i18next.t('leavePopup');
const beforeUnloadListener = (event: BeforeUnloadEvent) => {
    event.preventDefault();
    event.returnValue = beforeunloadMessage;
};
let unloadListener: { (): Promise<void> } | undefined = undefined;

// when user reload page on call, alert message and leave from the room.
export const addUnloadEventListener = (groupId: number, roomId: number): void => {
    // デフォルトの挙動では、beforeunloadの時点（popupがでる直前)にagoraのroomからleaveしてしまう
    // その結果、agoraでroomから抜けた判定になり、callback経由でcocalero-apiに伝えられる
    // cocalero-apiはcallbackを受け取った後に、roomから退出したとしてchat_group_room_usersを削除してしまう
    // 以上のためbeforeunloadでは何も行わないようにする
    // https://github.com/AgoraIO-Community/AgoraWebSDK-NG/issues/117
    window.addEventListener('beforeunload', beforeUnloadListener);
    unloadListener = async () => await ChatGroupRoomUserApi(groupId, roomId).leave();
    window.addEventListener('unload', unloadListener);
};

export const clearUnloadEventListener = (): void => {
    window.removeEventListener('beforeunload', beforeUnloadListener);
    if (unloadListener !== undefined) {
        window.removeEventListener('unload', unloadListener);
    }
};
